var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.fullName}},[_c('span',[_vm._v(_vm._s(_vm.choppedName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }